{
  "it": {
    "ai": {
      "assistant": {
        "all_projects": "Tutti i progetti",
        "cap": {
          "action": "Avvia una nuova conversazione",
          "message": "Ha raggiunto il limite di conversazioni."
        },
        "empty_state": {
          "subtitle": "Mi chieda qualsiasi cosa sui Suoi clienti",
          "title": "Come posso aiutarLa?"
        },
        "errors": {
          "budget_reached": "Il budget AI mensile per questo spazio di lavoro è stato raggiunto. Contatti un amministratore per aumentare il limite.",
          "generic": "Qualcosa è andato storto. Riprovi."
        },
        "history": {
          "empty": "Nessuna conversazione precedente",
          "title": "Conversazioni precedenti"
        },
        "input": {
          "disclaimer": "I risultati potrebbero non essere accurati. Verifichi sempre le informazioni importanti.",
          "hint": "Invio per inviare · Maiusc+Invio per andare a capo",
          "placeholder": "Chieda dei Suoi clienti…"
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Come configuro le notifiche?",
          "help_project_settings": "Dove trovo le impostazioni del progetto?",
          "open_decisions": "Quali decisioni sono ancora aperte?",
          "unassigned_units": "Quali unità non hanno ancora un cliente?"
        },
        "support_cta": {
          "action": "Contatta il supporto",
          "prompt": "Non è la risposta che cercava?"
        }
      },
      "settings": {
        "budget": {
          "budget_label": "Budget",
          "description": "Limite di spesa mensile per l'utilizzo dell'AI (fase di test). Ricalcolato in base all'utilizzo dei token in tutte le conversazioni di questo mese.",
          "save": "Salva",
          "title": "Budget mensile",
          "usage_label": "Utilizzato questo mese"
        },
        "description": "Configurazione delle funzionalità AI nel Suo spazio di lavoro.",
        "title": "Impostazioni AI"
      }
    }
  }
}
